import React from 'react'

class PreloadImage extends React.PureComponent {
  state = {
    isLoaded: false,
  }

  componentDidMount() {
    this.preloader = new Image()
    this.preloader.onload = () => this.setState({ isLoaded: true })
    this.preloader.src = this.props.image
  }

  componentWillUnmount() {
    this.preloader.onload = null
  }

  render() {
    return this.state.isLoaded && this.props.children(this.props.image)
  }
}

export default PreloadImage
